import { render } from "./SummerTrinkTineTc.vue?vue&type=template&id=877e2c26"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/SummerTrinkTineTc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "877e2c26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('877e2c26', __exports__)) {
    api.reload('877e2c26', __exports__)
  }
  
  module.hot.accept("./SummerTrinkTineTc.vue?vue&type=template&id=877e2c26", () => {
    api.rerender('877e2c26', render)
  })

}


export default __exports__